import { getBlazeAdmin } from '@blaze-cms/admin';
import buildConfig from '../blaze.config';

const app = getBlazeAdmin({ buildConfig });
app.render();
